import React, { PureComponent } from "react";
import pako from "pako/dist/pako.es5.js";
import moment from "moment";

import {
    isPrintMode,
    getPdfPrinter,
    getDebugPrinter,
    getUuid,
    isUsingLocalPrintServer
} from "./QueryParameter";
import { saveFile } from "./helpers/FileHelper";

export const STATE = {
    NONE: 0,
    PRINTING: 1,
    ERROR: 2
};

moment.fn.toJSON = function () {
    return this.format();
};

export function PDFWrapper(ComponentToWrap, product) {
    return class WrappedComponent extends PureComponent {
        state = {
            printState: STATE.NONE
        };

        isPrintMode = () => isPrintMode();

        pdfExporter = () => getPdfPrinter(window.location);

        printHost = () => getDebugPrinter(window.location);

        uuid = () => getUuid(window.location);

        onPrint = (
            wrappedState,
            filename,
            options = { printRoute: "", isPortrait: false, footer: "" }
        ) => {
            const stringifiedState = pako.deflate(JSON.stringify(wrappedState));
            this.setState({ printState: STATE.PRINTING });

            const { printRoute, isPortrait, footer } = options;
            const printRouteParam = printRoute ? `&printRoute=${printRoute}` : "";
            const isPortraitParam = isPortrait ? `&isPortrait=${isPortrait}` : "";
            const footerParam = footer ? `&footer=${footer}` : "";
            const debugPrinterParam = this.printHost() ? `&printHost=${this.printHost()}` : "";
            const contentTypeHeader = isUsingLocalPrintServer()
                ? "application/octet-stream"
                : "text/plain";
            const printerServerSuffix = `${
                this.pdfExporter().includes("?") ? "&" : "?"
            }product=${product}${isPortraitParam}${printRouteParam}${debugPrinterParam}${footerParam}`;

            fetch(`${this.pdfExporter()}${printerServerSuffix}`, {
                method: "POST",
                headers: {
                    "Content-Type": contentTypeHeader
                },
                body: stringifiedState
            })
                .then(resp => {
                    if (!resp.ok) {
                        throw new Error(resp);
                    }

                    return resp.blob();
                })
                .then(blob => {
                    saveFile(blob, filename);
                    this.setState({ printState: STATE.NONE });
                })
                .catch(() => this.setState({ printState: STATE.ERROR }));
        };

        componentDidUpdate() {
            if (this.state.stateFromPrint) {
                document.title = this.uuid();
            }
        }

        componentDidMount() {
            if (this.isPrintMode()) {
                this.setState({ printState: STATE.PRINTING });
                if (window.stateShare) {
                    window
                        .stateShare()
                        .then(pdfState => {
                            const decompressed = pako.inflate(new Buffer.from(pdfState, "base64"), {
                                to: "string"
                            });
                            const state = JSON.parse(decompressed);
                            this.setState({
                                stateFromPrint: true,
                                printState: STATE.NONE,
                                printingState: state
                            });
                        })
                        .catch(() => this.setState({ printState: STATE.ERROR }));
                } else {
                    this.setState({ printState: STATE.ERROR });
                }
            }
        }

        render() {
            return (
                <ComponentToWrap
                    {...this.props}
                    onPrint={this.onPrint}
                    printingState={this.state ? this.state.printingState : null}
                    printState={this.state.printState}
                    isPrintMode={this.isPrintMode()}
                />
            );
        }
    };
}
